export function parseMonth(value: string): number {
  const [year, month] = value.split("-").map(Number);
  return year * 12 + month - 1;
}

export function formatMonth(serial: number): string {
  const year = Math.floor(serial / 12);
  const month = (serial % 12) + 1;
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function addMonths(value: string, months: number): string {
  return formatMonth(parseMonth(value) + months);
}

export function diffMonths(start: string, end: string): number {
  return parseMonth(end) - parseMonth(start);
}

export function enumerateMonths(start: string, end: string): string[] {
  const first = parseMonth(start);
  const last = parseMonth(end);
  const months: string[] = [];
  for (let current = first; current <= last; current += 1) {
    months.push(formatMonth(current));
  }
  return months;
}

export function getYear(value: string): number {
  return Number(value.slice(0, 4));
}
